import { createTheme } from '@mui/material/styles';

import { CommonThemeOptions } from './commonTheme';
import type { IThemeOptions } from './index';

export const Sing2NotesOptions: IThemeOptions = {
  ...CommonThemeOptions,
  themeName: 'Sing2Notes',
  components: {
    ...CommonThemeOptions.components,
    MuiButton: {
      styleOverrides: {
        outlinedPrimary: {
          color: '#b25f5f',
          '&.Mui-disabled': {
            color: '#714747',
            border: '1px solid #714747',
          },
        },
        containedPrimary: {
          backgroundColor: '#b25f5f',
          '&.Mui-disabled': {
            backgroundColor: '#714747',
            color: '#212121',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        primary: {
          color: '#FFFFFF',
          backgroundColor: '#b25f5f',
          background: '#b25f5f',
          '&.Mui-disabled': {
            background: '#caced133',
            color: '#ffffff42',
          },
        },
      },
    },
  },
  palette: {
    ...CommonThemeOptions.palette,
    primary: {
      main: '#b25f5f',
      light: '#B88E73',
      dark: '#9b5353',
      contrastText: '#FFFFFF',
    },
  },
};

export const Sing2NotesTheme = createTheme(Sing2NotesOptions);
